export type VehicleRecommendationType = 'sale' | 'service' | 'rental';
